import { useContext } from 'react'
import { RecurringExportContext } from 'contexts/recurringExportContext'

export const useRecurringExportContext = () => {
  return useContext(RecurringExportContext)
}
